import { BrowserRouter, Route, Routes } from 'react-router-dom'; 
import Header from './components/header';
import Footer from './components/footer'; 
import Home from './pages/home';
import PropertyForSale from './pages/propertyforsale';
import PropertyForRent from './pages/propertyforrent';
import PropertySearchResult from './pages/propertysearchresult';
import NewProjects from './pages/newprojects';
import AboutUs from './pages/aboutus';
import ContactUs from "./pages/contactus";
import PropertyDetails from "./pages/propertydetail";
import OffplanDetails from "./pages/offplandetail";
import AreaDetails from "./pages/areadetail";
import BlogDetails from "./pages/blogdetail";
import Careers from "./pages/careers";
import TermsCondition from "./pages/termscondition";
import PrivacyPolicy from "./pages/privacypolicy";
import Disclaimer from "./pages/disclaimer";
import ScrollToTop from './components/ScrollToTop';
import LuxuryCollection from './pages/luxurycollection';
import Developers from './pages/developerlist';
import NewProjectsbyDeveloper from './pages/newprojectsbydeveloper';
import PropertyManagement from './pages/propertymanagement';
import Leasing from './pages/leasing';
import Sales from './pages/sales';
import Mortgage from './pages/mortgage';
import GoldenVisa from './pages/goldenvisa';
import Blogs from './pages/blog';
import OurTeam from './pages/ourteam';
import AgentDetails from './pages/agentdetails';
import AgentDetailsDemo from './pages/agentdetailsdemo';
import Testimonial from './pages/testimonial';
import PropertyByArea from './pages/propertybyarea';
import ListYourPropery from './pages/listyourproperties';
import RouteTransition from './components/RouteTransition';
import SEOManager from './components/SEOManager';

// New SEO PAGES
import ApartmentsToBuyInAbuDhabi from './pages/apartments-to-buy-in-abu-dhabi';
import BuyHouseAbuDhabi from "./pages/buy-house-abu-dhabi";
import TownhouseForSaleAbuDhabi from "./pages/townhouse-for-sale-abu-dhabi";
import TwoBhkForRentAbuDhabi from "./pages/2bhk-for-rent-abu-dhabi";
import OneBedroomFlatAbuDhabi from "./pages/one-bedroom-flat-abu-dhabi";
import OffPlanPropertiesAbuDhabi from "./pages/off-plan-properties-abu-dhabi";
import AbuDhabiHousesForSale from "./pages/abu-dhabi-houses-for-sale";
import LandForSaleAbuDhabi from "./pages/land-for-sale-abu-dhabi";
import FurnishedStudioRentAbuDhabi from "./pages/furnished-studio-rent-abu-dhabi";
import TwoBedroomApartmentRent from "./pages/2-bedroom-apartment-rent";
import OneBedroomApartmentRent from "./pages/1-bedroom-apartment-rent";
import SellYourPropertyInAbuDhabi from "./pages/sell-your-property-in-abu-dhabi";
import VillasToBuyAbuDhabi from "./pages/villas-to-buy-abu-dhabi";
import CommercialVillaForRentAbuDhabi from "./pages/commercial-villa-for-rent-abu-dhabi";
import VillasForSaleAbuDhabi from "./pages/villas-for-sale-abu-dhabi";
import RentalPropertyAbuDhabi from "./pages/rental-property-abu-dhabi";
// New SEO PAGES END

function App() {
  return (
     <>
      <BrowserRouter>
       <ScrollToTop />
     <SEOManager />
     <RouteTransition />
     <Header/>
     <Routes>
      <Route path="/" element={<Home />} />  
      <Route path="/sell-your-property" element={<ListYourPropery />} />  
       <Route path="/properties-for-sale" element={<PropertyForSale />} /> 
       <Route path="/property-management" element={<PropertyManagement />} /> 
       <Route path="/mortgage" element={<Mortgage />} /> 
       <Route path="/leasing" element={<Leasing />} /> 
       <Route path="/sales" element={<Sales />} /> 
       <Route path="/golden-visa-and-property-residency" element={<GoldenVisa />} />
        <Route path="/archive-properties/villas-for-sale-abu-dhabi" element={<VillasForSaleAbuDhabi />} />
       <Route path="/blogs" element={<Blogs />} /> 
       <Route path="/team" element={<OurTeam />} /> 
       <Route path="/team/:title/:id" element={<AgentDetails />} /> 
       <Route path="/demo-team/:title/:id" element={<AgentDetailsDemo />} /> 
       <Route path="/properties-for-rent" element={<PropertyForRent />} /> 
       <Route path="/:title/:id" element={<PropertyByArea />} /> 
       <Route path="/property-search-result" element={<PropertySearchResult />} /> 
       <Route path="/new-projects" element={<NewProjects />} /> 
       <Route path="/developers/:title/:id" element={<NewProjectsbyDeveloper />} /> 
       <Route path="/luxury-collection" element={<LuxuryCollection />} /> 
       <Route path="/about-us" element={<AboutUs />} /> 
       <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/property/:title/:id" element={<PropertyDetails />} /> 
        <Route path="/off-plan-property/:title/:id" element={<OffplanDetails />} /> 
        <Route path="/area-guide/:title/:id" element={<AreaDetails />} /> 
        <Route path="/blog/:title/:id" element={<BlogDetails />} /> 
        <Route path="/careers" element={<Careers />} /> 
        <Route path="/terms-and-conditions" element={<TermsCondition />} /> 
        <Route path="/privacy-policy" element={<PrivacyPolicy />} /> 
        <Route path="/disclaimer" element={<Disclaimer />} /> 
        <Route path="/developers" element={<Developers />} /> 
        <Route path="/testimonials" element={<Testimonial />} /> 
        <Route
        path="/apartments-to-buy-in-abu-dhabi"
        element={<ApartmentsToBuyInAbuDhabi />}
      />

      <Route
        path="/buy-house-abu-dhabi"
        element={<BuyHouseAbuDhabi />}
      />

      <Route
        path="/townhouse-for-sale-abu-dhabi"
        element={<TownhouseForSaleAbuDhabi />}
      />

      <Route
        path="/2bhk-for-rent-abu-dhabi"
        element={<TwoBhkForRentAbuDhabi />}
      />

      <Route
        path="/one-bedroom-flat-abu-dhabi"
        element={<OneBedroomFlatAbuDhabi />}
      />

      <Route
        path="/off-plan-properties-abu-dhabi"
        element={<OffPlanPropertiesAbuDhabi />}
      />

      <Route
        path="/abu-dhabi-houses-for-sale"
        element={<AbuDhabiHousesForSale />}
      />

      <Route
        path="/land-for-sale-abu-dhabi"
        element={<LandForSaleAbuDhabi />}
      />

      <Route
        path="/furnished-studio-rent-abu-dhabi"
        element={<FurnishedStudioRentAbuDhabi />}
      />

      <Route
        path="/2-bedroom-apartment-rent"
        element={<TwoBedroomApartmentRent />}
      />

      <Route
        path="/1-bedroom-apartment-rent"
        element={<OneBedroomApartmentRent />}
      />

      <Route
        path="/sell-your-property-in-abu-dhabi"
        element={<SellYourPropertyInAbuDhabi />}
      />

      <Route
        path="/villas-to-buy-abu-dhabi"
        element={<VillasToBuyAbuDhabi />}
      />

      <Route
        path="/commercial-villa-for-rent-abu-dhabi"
        element={<CommercialVillaForRentAbuDhabi />}
      />

      <Route
        path="/villas-for-sale-abu-dhabi"
        element={<VillasForSaleAbuDhabi />}
      />

      <Route
        path="/rental-property-abu-dhabi"
        element={<RentalPropertyAbuDhabi />}
      />
      </Routes>
     <Footer/>
     </BrowserRouter>
     </>
  );
}

export default App;
